import React, { lazy } from 'react'
import { Route } from 'react-router'

const GroupComponent = lazy(() => import('../components/group/GroupComponent'))
const GroupFormPageComponent = lazy(() => import('../components/group/GroupFormPageComponent'))
const GroupLatePunsihmentComponent = lazy(() => import('../components/group/GroupLatePunishmentListComponent'))

const GroupRoute = () => {
  return (
    <>
      <Route exact path='/manage/group' component={GroupComponent} />
      <Route exact path='/manage/group/create' component={GroupFormPageComponent} />
      <Route exact path='/manage/group/:id/edit' component={GroupFormPageComponent} />
      <Route exact path='/manage/group/:id/punishment' component={GroupLatePunsihmentComponent} />
    </>
  )
}

export default GroupRoute
